import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const slideUp = keyframes`
  from {
    top: -70px;
    opacity: 0;
  }
  to {
    top: -75px;
    opacity: 1;
  }
`;

export const Bubble = styled.div<{ isOpen: boolean }>`
  ${({ theme, isOpen }) => css`
    position: absolute;
    left: 50%;
    padding: 8px 14px;
    transform: translateX(-50%);
    animation: ${isOpen
      ? css`
          ${slideUp} 0.3s ease-out forwards
        `
      : 'none'};
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 35px;
    background: ${theme.backgroundColor.bg_dark_1};
    backdrop-filter: blur(50px);

    &::after {
      content: '';
      display: block;
      position: absolute;
      z-index: 1;
      bottom: -8px;
      left: 50%;
      width: 0;
      transform: translateX(-50%);
      border-width: 8px 6px 0px 6.5px;
      border-style: solid;
      border-color: ${theme.backgroundColor.bg_dark_1} transparent;
    }

    &::before {
      content: '';
      display: block;
      position: absolute;
      z-index: 0;
      bottom: -9.5px;
      left: 50%;
      width: 0;
      transform: translateX(-50%);
      border-width: 9px 7px 0px 7.5px;
      border-style: solid;
      border-color: ${theme.stroke.stroke_1} transparent;
    }

    & > div {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `}
`;

export const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 100%;
  margin: 0 auto;
`;
